export default __webpack_public_path__ + "static/lock-screen-widgets-f941f69b3be0910d8343f57d4b6c5de8.mp4";